var map = {
	"./bg-tentang-kami-daun.png": "./src/assets/img/tentang-kami/bg-tentang-kami-daun.png",
	"./bg-tentang-kami-direksi.png": "./src/assets/img/tentang-kami/bg-tentang-kami-direksi.png",
	"./misi.png": "./src/assets/img/tentang-kami/misi.png",
	"./pa-azhar-bw.png": "./src/assets/img/tentang-kami/pa-azhar-bw.png",
	"./pa-uki-bw.png": "./src/assets/img/tentang-kami/pa-uki-bw.png",
	"./photo-azhar.png": "./src/assets/img/tentang-kami/photo-azhar.png",
	"./photo-edwin.png": "./src/assets/img/tentang-kami/photo-edwin.png",
	"./photo-ir.png": "./src/assets/img/tentang-kami/photo-ir.png",
	"./photo-uki.png": "./src/assets/img/tentang-kami/photo-uki.png",
	"./visi.png": "./src/assets/img/tentang-kami/visi.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/tentang-kami sync recursive ^\\.\\/.*\\.png$";